<template>
  <div>
    <div
      class="modal fade"
      :ref="`modal-external-link`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  extarnalLinkData.id === 0
                    ? "externalLink.addNew"
                    : "externalLink.detail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group required">
                          <label class="control-label" for="">{{
                            $t("externalLink.externalLinkTitle")
                          }}</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="extarnalLinkData.title"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group required">
                          <label class="control-label" for="">{{
                            $t("externalLink.urlAddress")
                          }}</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="extarnalLinkData.urlAddress"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="exampleCheck1"
                              v-model="extarnalLinkData.enable"
                            />
                            <label
                              class="form-check-label"
                              for="exampleCheck1"
                              >{{ $t("common.enable") }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("service.iconAppMobile")
                      }}</label>
                      <div>
                        <img
                          id="apartment-img-id"
                          class="asset-img-class img-responsive"
                          :src="
                            extarnalLinkData.iconMobile !== null &&
                            extarnalLinkData.iconMobile !== ''
                              ? extarnalLinkData.iconMobile
                              : noImgDefault
                          "
                          alt="asset-img"
                          @click="onOpenInputIconMobile()"
                        />
                        <div style="padding-top: 6px; text-align: center">
                          <input
                            :id="`upload-icon-mobile`"
                            type="file"
                            accept="image/*"
                            @change="onSelectAssetImg"
                          />
                          <p>
                            <small>{{
                              $t("banner.clickImageToAddOrUpdate")
                            }}</small>
                          </p>
                          <span
                            v-if="
                              extarnalLinkData.iconMobile !== null &&
                                extarnalLinkData.iconMobile !== ''
                            "
                            class="remove-asset-img"
                            @click="onClickRemoveIconMobile"
                            >{{ $t("common.delete") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSave"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
      <!--  -->
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import utils from '@/lib/utils';
import configuration from "@/lib/config";
import LTECoreAlert from "@/components/LTESnackBar.vue";

// import constantsData from "@/lib/constantsData";

export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
    extarnalLinkData: {
      id: 0,
      title: null,
      iconMobile: null,
      urlAddress: null,
      enable: false
    },
    media_server: {
      domain: "",
      token: ""
    },
    iconMobileFileSize: null
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_TOKEN_UPLOAD_DATA"
    ])
  },
  methods: {
    onCloseModal: function() {
      $(this.$refs[`modal-external-link`]).modal("hide");
    },
    onShowModal: function() {
      $(this.$refs[`modal-external-link`]).modal("show");
    },
    addNew: function() {
      this.extarnalLinkData = {
        id: 0,
        title: null,
        iconMobile: null,
        urlAddress: null,
        enable: false
      };
      this.onShowModal();
    },
    showDetail: function(data) {
      this.extarnalLinkData = {
        id: data.id,
        title: data.title,
        iconMobile: data.iconUrl,
        urlAddress: data.urlAddress,
        enable: data.enable
      };
      this.onShowModal();
    },
    // icon mobile
    onOpenInputSelectFile: function() {
      $(`#upload-icon-mobile`).val("");
      $(`#upload-icon-mobile`).click();
    },
    onOpenInputIconMobile: function() {
      this.uploadServiceType = this.uploadServiceIcon;
      this.onOpenInputSelectFile();
    },
    onClickRemoveIconMobile: function() {
      this.serviceData.iconMobile = null;
    },
    onSelectAssetImg: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.iconMobileFileSize = files[0].size;
      // this.extarnalLinkData.iconMobile = URL.createObjectURL(files[0]);
      this.uploadImgFunction();
    },
    getResultFile: function(file) {
      let vm = this;
      vm.iconMobileFile = file;
    },
    uploadImgFunction: async function() {
      if (this.iconMobileFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.iconMobileFile);
        formData.append("directory", "externalLink");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              this.extarnalLinkData.iconMobile = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onSave: function() {
      if (utils.isEmptyString(this.extarnalLinkData.title)) {
        this.ON_SHOW_TOAST({
          message: this.$t("externalLink.externalLinkTitle"),
          styleType: "danger"
        });
      } else if (utils.isEmptyString(this.extarnalLinkData.urlAddress)) {
        this.ON_SHOW_TOAST({
          message: this.$t("externalLink.urlAddress"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.extarnalLinkData.id,
          title: this.extarnalLinkData.title,
          iconUrl: this.extarnalLinkData.iconMobile,
          externalLink: this.extarnalLinkData.urlAddress,
          enable: this.extarnalLinkData.enable
        };
        if (this.extarnalLinkData.id === 0) {
          this.CREATE_EXTERNAL_LINK(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.$emit("callbackExternalLinkList", true);
                this.onCloseModal();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_EXTERNAL_LINK(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.$emit("callbackExternalLinkList", true);
                this.onCloseModal();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_EXTERNAL_LINK",
      "UPDATE_EXTERNAL_LINK"
    ])
  }
};
</script>
<style scoped>
.disable-input-background {
  background: #e4e7e8;
}
input[type="file"] {
  display: none;
}
.form-group.required .control-label:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 150px;
  max-height: 150px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeMobileManagement/ExternalLinkModal.vue